

import { FontFamily as TiptapFontFamily } from '@tiptap/extension-font-family'
import { FontFamilyActionMenuButton } from '@/tiptap/extensions/components/ActionMenuButton'
import { DEFAULT_FONT_FAMILY_LIST } from '@/tiptap/constants/define'

// JS version of the TS extension wrapper with menu button
export const FontFamily = TiptapFontFamily.extend({
  addOptions() {
    const parent = (this.parent && this.parent()) || {}
    return {
      ...parent,
      // allow external override via configure({ fontFamilies: [...] })
      fontFamilies: parent.fontFamilies ?? DEFAULT_FONT_FAMILY_LIST,
      button: ({ editor, extension, t }) => ({
        component: FontFamilyActionMenuButton,
        componentProps: { editor, extension, t }
      })
    }
  }
})

export default FontFamily
